import { Injectable } from "@angular/core";

import { MapperInterface } from "./mapper-inteface";

import { RiferimentiPosizioneDTO } from "../dto/riferimento-posizioneDTO";

import { RiferimentiPosizioneVO } from "../vo/riferimenti-posizioneVO";
import { RichiestaFirmaDTO } from "../dto/protocollo/richiesta-firmaDTO";
import { RichiestaFirmaVO } from "../vo/richiesta-firmaVO";
import { MapperFirmatario } from "./mapper-firmatario";

@Injectable({
  providedIn: "root"
})
export class MapperRichiestaFirma
  implements MapperInterface<RichiestaFirmaDTO, RichiestaFirmaVO> {
    
    constructor(private mapperFirmatario: MapperFirmatario){}

    convertVoToDto(richiestaFirmaVO: RichiestaFirmaVO): RichiestaFirmaDTO {

    const richiestaFirmaDTO = new RichiestaFirmaDTO();
    richiestaFirmaDTO.idDocumento = richiestaFirmaVO.idDocumento;
    richiestaFirmaDTO.firmatario = this.mapperFirmatario.convertVoToDto(richiestaFirmaVO.firmatario);

    return richiestaFirmaDTO || new RichiestaFirmaDTO();
    }

    convertDtoToVo(t: RichiestaFirmaDTO): RichiestaFirmaVO {
        throw new Error("Method not implemented.");
    }
    convertListVoToDto(e: any[]): RichiestaFirmaDTO[] {
        throw new Error("Method not implemented.");
    }
    convertListDtoToVo(t: RichiestaFirmaDTO[]): any[] {
        throw new Error("Method not implemented.");
    }
}
